import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'context'
import { AppState } from 'interfaces/app'
import Info from '@mui/icons-material/Info'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import Tooltip from '@mui/material/Tooltip'
import './index.css'

export interface CustomTooltipProps {
  tooltipText?: string
}

export const CustomTooltip: FC<CustomTooltipProps> = ({ tooltipText }) => {
  const { isMobile } = useSelector<RootState, AppState>((state) => state.app)
  const [openTooltip, setOpenTooltip] = React.useState(false)
  const handleTooltipClick = () => {
    setOpenTooltip(!openTooltip)
  }

  const getComponent = () => {
    if (!tooltipText) {
      return <div className="space bp-ml-4"></div>
    }
    return (
      <>
        {isMobile ? (
          <ClickAwayListener
            onClickAway={() => {
              setOpenTooltip(false)
            }}
          >
            <Tooltip
              PopperProps={{ disablePortal: true }}
              className="bp-ml-4"
              title={tooltipText}
              onClose={handleTooltipClick}
              open={openTooltip}
              disableFocusListener
              disableHoverListener
              disableTouchListener
            >
              <Info
                onClick={handleTooltipClick}
                className={'info-color tooltip-size'}
              />
            </Tooltip>
          </ClickAwayListener>
        ) : (
          <Tooltip className="bp-ml-4" title={tooltipText} arrow>
            <Info className="info-color tooltip-size " />
          </Tooltip>
        )}
      </>
    )
  }

  return (
    <>
      {getComponent()}
    </>
  )
}
